import React from 'react';

import { GenericAsyncSelect } from 'src/views/components/select';

const urgencyOptions = [
  { value: 'high', label: 'High' },
  { value: 'low', label: 'Low' }
];

const IncidentUrgencySelect = (props) => {
  return (
    <GenericAsyncSelect
      valueFieldName="value"
      placeholder="Select urgency..."
      options={urgencyOptions}
      {...props}
    />
  );
};

export default IncidentUrgencySelect;
